class Entity {
  constructor(attrs) {
    Object.assign(this, attrs);
  }
}

export default class PortalCliente extends Entity {
  static get modelName() {
    return 'PortalCliente'
  }

}
